import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {FilterBoxConfiguration} from '../../../../../shared/components/filterable-grid/filter-group/filter-box.component';

@Injectable()
export class LicensesSummaryService {

  constructor() { }

  private getProductType(): string[] {
    return [
      // 'Course Supplement',
      // 'Course Video',
      'Courseware',
      'Instructor Package',
      'Exam',
      'Instructor Supporting Material',
      'Learner Supporting Material',
      'Instructor Material'
    ].sort()
  }

  private typeToOptions(): { checked: boolean, key: string, required: boolean, value: string, frequency: number }[] {
    return this.getProductType().map(val => ({ checked: true, key: val, required: true, value: val, frequency: 0 }))
  }
  public getFilters(): Observable<FilterBoxConfiguration[]> {
    return Observable.of([
      {
        title: 'Vouchers',
        key: 'noVoucher',
        show: true,
        state: 'true',
        options: [{
          checked: true, key: 'noVoucher', required: true, value: 'Show products with no available vouchers', frequency: 0
        }],
        cutOffLower: 3,
        minOnly: 2
      },
      {
        title: 'Product Type',
        key: 'product.type',
        show: true,
        state: '',
        options: this.typeToOptions(),
        cutOffLower: 3,
        minOnly: 2
      }])
  }
  setDeliveryFormatCheckboxDisabled(filterFilters: string): any {
    return {
      paperExam: !filterFilters.includes('Exam'),
      onlineExam: !filterFilters.includes('Exam'),
      proctorExam: !filterFilters.includes('Exam'),
      eBook: !(filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material') || filterFilters.includes('Instructor Package')),
      eLearning: !(filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material')),
      video: !(filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material')),
      presentation: !(filterFilters.includes('Instructor Supporting Material') || filterFilters.includes('Learner Supporting Material') || filterFilters.includes('Instructor Material') || filterFilters.includes('Instructor Package'))
    }
  }
  setDeliveryFormatDisabledToFalse(filterFilters: string): any {
    return {
      paperExam: filterFilters.includes('Exam'),
      onlineExam: filterFilters.includes('Exam'),
      proctorExam: filterFilters.includes('Exam'),
      eBook: (filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material') || filterFilters.includes('Instructor Package')),
      eLearning: (filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material')),
      video: (filterFilters.includes('Courseware') || filterFilters.includes('Instructor Material') || filterFilters.includes('Learner Supporting Material') ||
        filterFilters.includes('Instructor Supporting Material')),
      presentation: (filterFilters.includes('Instructor Supporting Material') || filterFilters.includes('Learner Supporting Material') || filterFilters.includes('Instructor Material') || filterFilters.includes('Instructor Package'))
    }
  }
  deliverFormatResultsToUrlStr(deliveryFormatCheckboxResults: any): string {
    let res = '&@deliveryFormat=';
    if (deliveryFormatCheckboxResults.paperExam) res += 'Paper Exam,'
    if (deliveryFormatCheckboxResults.onlineExam) res += 'Online Exam,'
    if (deliveryFormatCheckboxResults.proctorExam) res += 'Proctor Exam,'
    if (deliveryFormatCheckboxResults.presentation) res += 'Presentation,'
    if (deliveryFormatCheckboxResults.eBook) res += 'eBook,'
    if (deliveryFormatCheckboxResults.eLearning) res += 'eLearning,'
    if (deliveryFormatCheckboxResults.video) res += 'Video,'
    res = res.slice(0, -1);
    res += '&and=1'
    return res;

  }
}



// WEBPACK FOOTER //
// ./src/app/solar/vouchers/components/licenses/summary/licenses-summary.stub.ts